import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\HearingAssessmentController::saveDraft
* @see app/Http/Controllers/HearingAssessmentController.php:66
* @route '/hearing-assessment/save'
*/
export const saveDraft = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: saveDraft.url(options),
    method: 'post',
})

saveDraft.definition = {
    methods: ["post"],
    url: '/hearing-assessment/save',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\HearingAssessmentController::saveDraft
* @see app/Http/Controllers/HearingAssessmentController.php:66
* @route '/hearing-assessment/save'
*/
saveDraft.url = (options?: RouteQueryOptions) => {
    return saveDraft.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HearingAssessmentController::saveDraft
* @see app/Http/Controllers/HearingAssessmentController.php:66
* @route '/hearing-assessment/save'
*/
saveDraft.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: saveDraft.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::saveDraft
* @see app/Http/Controllers/HearingAssessmentController.php:66
* @route '/hearing-assessment/save'
*/
const saveDraftForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: saveDraft.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::saveDraft
* @see app/Http/Controllers/HearingAssessmentController.php:66
* @route '/hearing-assessment/save'
*/
saveDraftForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: saveDraft.url(options),
    method: 'post',
})

saveDraft.form = saveDraftForm

/**
* @see \App\Http\Controllers\HearingAssessmentController::resume
* @see app/Http/Controllers/HearingAssessmentController.php:104
* @route '/hearing-assessment/resume'
*/
export const resume = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: resume.url(options),
    method: 'get',
})

resume.definition = {
    methods: ["get","head"],
    url: '/hearing-assessment/resume',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HearingAssessmentController::resume
* @see app/Http/Controllers/HearingAssessmentController.php:104
* @route '/hearing-assessment/resume'
*/
resume.url = (options?: RouteQueryOptions) => {
    return resume.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HearingAssessmentController::resume
* @see app/Http/Controllers/HearingAssessmentController.php:104
* @route '/hearing-assessment/resume'
*/
resume.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: resume.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::resume
* @see app/Http/Controllers/HearingAssessmentController.php:104
* @route '/hearing-assessment/resume'
*/
resume.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: resume.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::resume
* @see app/Http/Controllers/HearingAssessmentController.php:104
* @route '/hearing-assessment/resume'
*/
const resumeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resume.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::resume
* @see app/Http/Controllers/HearingAssessmentController.php:104
* @route '/hearing-assessment/resume'
*/
resumeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resume.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::resume
* @see app/Http/Controllers/HearingAssessmentController.php:104
* @route '/hearing-assessment/resume'
*/
resumeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resume.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

resume.form = resumeForm

/**
* @see \App\Http\Controllers\HearingAssessmentController::results
* @see app/Http/Controllers/HearingAssessmentController.php:140
* @route '/hearing-assessment/results'
*/
export const results = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: results.url(options),
    method: 'get',
})

results.definition = {
    methods: ["get","head"],
    url: '/hearing-assessment/results',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HearingAssessmentController::results
* @see app/Http/Controllers/HearingAssessmentController.php:140
* @route '/hearing-assessment/results'
*/
results.url = (options?: RouteQueryOptions) => {
    return results.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HearingAssessmentController::results
* @see app/Http/Controllers/HearingAssessmentController.php:140
* @route '/hearing-assessment/results'
*/
results.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: results.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::results
* @see app/Http/Controllers/HearingAssessmentController.php:140
* @route '/hearing-assessment/results'
*/
results.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: results.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::results
* @see app/Http/Controllers/HearingAssessmentController.php:140
* @route '/hearing-assessment/results'
*/
const resultsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: results.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::results
* @see app/Http/Controllers/HearingAssessmentController.php:140
* @route '/hearing-assessment/results'
*/
resultsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: results.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::results
* @see app/Http/Controllers/HearingAssessmentController.php:140
* @route '/hearing-assessment/results'
*/
resultsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: results.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

results.form = resultsForm

/**
* @see \App\Http\Controllers\HearingAssessmentController::resultsStandalone
* @see app/Http/Controllers/HearingAssessmentController.php:164
* @route '/hearing-assessment/results/view'
*/
export const resultsStandalone = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: resultsStandalone.url(options),
    method: 'get',
})

resultsStandalone.definition = {
    methods: ["get","head"],
    url: '/hearing-assessment/results/view',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HearingAssessmentController::resultsStandalone
* @see app/Http/Controllers/HearingAssessmentController.php:164
* @route '/hearing-assessment/results/view'
*/
resultsStandalone.url = (options?: RouteQueryOptions) => {
    return resultsStandalone.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HearingAssessmentController::resultsStandalone
* @see app/Http/Controllers/HearingAssessmentController.php:164
* @route '/hearing-assessment/results/view'
*/
resultsStandalone.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: resultsStandalone.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::resultsStandalone
* @see app/Http/Controllers/HearingAssessmentController.php:164
* @route '/hearing-assessment/results/view'
*/
resultsStandalone.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: resultsStandalone.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::resultsStandalone
* @see app/Http/Controllers/HearingAssessmentController.php:164
* @route '/hearing-assessment/results/view'
*/
const resultsStandaloneForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resultsStandalone.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::resultsStandalone
* @see app/Http/Controllers/HearingAssessmentController.php:164
* @route '/hearing-assessment/results/view'
*/
resultsStandaloneForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resultsStandalone.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::resultsStandalone
* @see app/Http/Controllers/HearingAssessmentController.php:164
* @route '/hearing-assessment/results/view'
*/
resultsStandaloneForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resultsStandalone.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

resultsStandalone.form = resultsStandaloneForm

/**
* @see \App\Http\Controllers\HearingAssessmentController::submitContact
* @see app/Http/Controllers/HearingAssessmentController.php:195
* @route '/hearing-assessment/submit-contact'
*/
export const submitContact = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submitContact.url(options),
    method: 'post',
})

submitContact.definition = {
    methods: ["post"],
    url: '/hearing-assessment/submit-contact',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\HearingAssessmentController::submitContact
* @see app/Http/Controllers/HearingAssessmentController.php:195
* @route '/hearing-assessment/submit-contact'
*/
submitContact.url = (options?: RouteQueryOptions) => {
    return submitContact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HearingAssessmentController::submitContact
* @see app/Http/Controllers/HearingAssessmentController.php:195
* @route '/hearing-assessment/submit-contact'
*/
submitContact.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submitContact.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::submitContact
* @see app/Http/Controllers/HearingAssessmentController.php:195
* @route '/hearing-assessment/submit-contact'
*/
const submitContactForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submitContact.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::submitContact
* @see app/Http/Controllers/HearingAssessmentController.php:195
* @route '/hearing-assessment/submit-contact'
*/
submitContactForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submitContact.url(options),
    method: 'post',
})

submitContact.form = submitContactForm

/**
* @see \App\Http\Controllers\HearingAssessmentController::create
* @see app/Http/Controllers/HearingAssessmentController.php:24
* @route '/hearing-assessment'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/hearing-assessment',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HearingAssessmentController::create
* @see app/Http/Controllers/HearingAssessmentController.php:24
* @route '/hearing-assessment'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HearingAssessmentController::create
* @see app/Http/Controllers/HearingAssessmentController.php:24
* @route '/hearing-assessment'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::create
* @see app/Http/Controllers/HearingAssessmentController.php:24
* @route '/hearing-assessment'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::create
* @see app/Http/Controllers/HearingAssessmentController.php:24
* @route '/hearing-assessment'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::create
* @see app/Http/Controllers/HearingAssessmentController.php:24
* @route '/hearing-assessment'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::create
* @see app/Http/Controllers/HearingAssessmentController.php:24
* @route '/hearing-assessment'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\HearingAssessmentController::store
* @see app/Http/Controllers/HearingAssessmentController.php:33
* @route '/hearing-assessment'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/hearing-assessment',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\HearingAssessmentController::store
* @see app/Http/Controllers/HearingAssessmentController.php:33
* @route '/hearing-assessment'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HearingAssessmentController::store
* @see app/Http/Controllers/HearingAssessmentController.php:33
* @route '/hearing-assessment'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::store
* @see app/Http/Controllers/HearingAssessmentController.php:33
* @route '/hearing-assessment'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\HearingAssessmentController::store
* @see app/Http/Controllers/HearingAssessmentController.php:33
* @route '/hearing-assessment'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const hearingAssessment = {
    saveDraft: Object.assign(saveDraft, saveDraft),
    resume: Object.assign(resume, resume),
    results: Object.assign(results, results),
    resultsStandalone: Object.assign(resultsStandalone, resultsStandalone),
    submitContact: Object.assign(submitContact, submitContact),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
}

export default hearingAssessment